<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Ref } from '@/helpers/Decorators';
import { Form, FormType } from '@/helpers/Form';
import IdeoModal from '@/components/ideo/modal/IdeoModal.vue';
import RegisterTasksService from '../services/RegisterTasksService';

@Options({
    emits: ['reload'],
})
export default class ChangeModuleModal extends Vue
{
    @Ref('change-module-modal') public modal: () => IdeoModal;

    public form: FormType<any> = Form.create<any>({
        module: null,
    });

    public documentData: any = null;

    public mounted(): void
    {
        this.$events.$on('change-module-modal', (documentData: any) =>
        {
            this.documentData = documentData;
            this.modal().show();
        });
    }

    public unmounted(): void
    {
        this.$events.$off('change-module-modal');
    }

    public async onSubmit(): Promise<void>
    {
        try
        {
            this.form.wait();

            await RegisterTasksService.changeModule(this.documentData.publicId, this.form.module.key);

            this.$alert.success(this.$t('[[[Moduł został zmieniony pomyślnie.]]]'));
            this.hideModal();
            this.$emit('reload');
        }
        catch (ex)
        {
            this.handleException(ex, {
                400: (ex: any) => this.$alert.warning(ex.message),
                422: (ex: any) => [
                    this.form.$errors.record(ex.data.errors),
                    this.$nextTick(() => this.$scrollTo('.invalid-field')),
                    this.$nextTick(() =>
                        this.$alert.warning(this.$t('[[[Nie wszystkie pola zostały wypełnione prawidłowo.]]]'))
                    ),
                ],
            });
        }
        finally
        {
            this.form.continue();
        }
    }

    public hideModal(): void
    {
        this.modal().hide();
        this.form.clear();
        this.documentData = null;
    }
}
</script>

<template>
    <IdeoModal
        ref="change-module-modal"
        :title="$t('[[[Zmień moduł]]]')"
        centered
    >
        <template #default>
            <form
                id="change-module-form"
                @submit.prevent="onSubmit"
                @keydown="form.$errors.clear(($event.target as HTMLInputElement).name)"
            >
                <!-- Module Selection -->
                <IdeoFormGroup
                    name="module"
                    :label="$t('[[[Typ dokumentu]]]')"
                    :invalid-feedback="form.$errors.first('module')"
                    :state="form.$errors.state('module')"
                    required
                >
                    <IdeoSelect
                        v-model="form.module"
                        :placeholder="$t('[[[Typ dokumentu]]]')"
                        :endpoint="`simple-dictionary/office/form/module`"
                        :preselect-when-one-option="false"
                        @update:modelValue="form.$errors.clear('module')"
                    />
                </IdeoFormGroup>
            </form>
        </template>
        <template #modal-footer="{ cancel }">
            <ActionButton
                form="change-module-form"
                variant="success"
                :text="$t('[[[Zapisz]]]')"
                :confirm="$t('[[[Czy na pewno chcesz zmienić moduł, wszystkie dane formularza zostaną utracone.]]]')"
                :disabled="!form.active() || !form.module"
                @click="onSubmit"
            />
            <IdeoButton variant="secondary" @click="cancel()">{{ $t('[[[Anuluj]]]') }}</IdeoButton>
        </template>
    </IdeoModal>
</template>
